import { Row, Col, Modal, Button, ListGroup } from "react-bootstrap";
import { Icon } from "@iconify/react";
const OrderVelocity = ({ order, show, onHide, selectedId }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="!text-base font-medium">Order Velocity</Modal.Title>
      </Modal.Header>
      <Modal.Body className="!text-sm">
        {order ? (
          <div>

            {/* Display svc_order_line details if available */}
            {order.order_velocity && order.order_velocity.length > 0 && (
              <>
                <h5>Order# {order.order_id} movement</h5>
                <ListGroup>
                  {order.order_velocity.map((line, index) => (
                    <ListGroup.Item key={index}>
                      <div>
                        <Row>
                          <Col>
                            {line.s_status_cd}
                          </Col>
                          <Col>
                            {line.sys_crte_tsp.substring(0, 19)}
                          </Col>
                          <Col>
                            {line.cumulative_minutes} mins
                          </Col>
                        </Row>
                      </div>

                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </div>
        ) : (
          <p>No order details available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          className="w-full !rounded-md !max-w-24 !text-sm text-black !bg-white h-[43px] !border-[#E9E9E9]"
        >
          Close
        </Button>

      </Modal.Footer>
    </Modal>
  );
};

export default OrderVelocity;
